import React from 'react';
import { CTAButton } from './CTAButton';
export function ChapterFiveSection() {
  return <section className="bg-white py-[100px] px-5" data-id="element-52">
      <div className="max-w-[1040px] mx-auto" data-id="element-53">
        <div className="text-center mb-12" data-id="element-54">
          <p className="font-sans text-[12px] font-bold text-gold-accent tracking-[0.3em] uppercase mb-6" data-id="element-55">
            ⭐ THE CHAPTER THAT PAYS FOR THIS BOOK BEFORE YOU FINISH IT
          </p>
          <h2 className="font-serif text-[36px] md:text-[54px] text-primary-dark leading-[1.1] max-w-[700px] mx-auto mb-8" data-id="element-56">
            One 12-Minute Phone Call.
            <br data-id="element-57" />
            $50 to $100 Back.
            <br data-id="element-58" />
            <span className="italic text-gold-accent" data-id="element-59">
              Every. Single. Month.
            </span>
          </h2>
          <div className="font-sans text-[18px] text-primary-dark/70 max-w-[620px] mx-auto leading-relaxed" data-id="element-60">
            <p className="mb-4" data-id="element-61">
              Chapter 5 doesn't tell you to negotiate your interest rate.
              <br data-id="element-62" />
              It gives you the word-for-word script.
            </p>
            <p className="mb-4" data-id="element-63">
              The exact sentences, in the exact order.
              <br data-id="element-64" />
              The rebuttal for when they say no.
              <br data-id="element-65" />
              The retention department strategy.
              <br data-id="element-66" />
              The callback plan for the second attempt.
            </p>
            <p className="font-bold text-primary-dark" data-id="element-67">
              You read it out loud. That's it.
            </p>
          </div>
        </div>

        {/* 3 Proof Stats */}
        <div className="bg-cream-light rounded-xl p-[40px] max-w-[700px] mx-auto mb-16" data-id="element-68">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-69">
            <div className="flex flex-col items-center" data-id="element-70">
              <span className="font-serif text-[48px] md:text-[56px] text-primary-emerald leading-none mb-2" data-id="element-71">
                84%
              </span>
              <span className="font-sans text-[12px] uppercase tracking-wider text-primary-dark/60 font-bold" data-id="element-72">
                Success Rate
              </span>
              <span className="font-sans text-[13px] italic text-primary-dark/50 mt-1" data-id="element-73">
                on the first call
              </span>
            </div>
            <div className="flex flex-col items-center" data-id="element-74">
              <span className="font-serif text-[48px] md:text-[56px] text-primary-emerald leading-none mb-2" data-id="element-75">
                12 min
              </span>
              <span className="font-sans text-[12px] uppercase tracking-wider text-primary-dark/60 font-bold" data-id="element-76">
                Average Call Duration
              </span>
              <span className="font-sans text-[13px] italic text-primary-dark/50 mt-1" data-id="element-77">
                from dial to confirmation
              </span>
            </div>
            <div className="flex flex-col items-center" data-id="element-78">
              <span className="font-serif text-[48px] md:text-[56px] text-success-green leading-none mb-2" data-id="element-79">
                $100+
              </span>
              <span className="font-sans text-[12px] uppercase tracking-wider text-primary-dark/60 font-bold" data-id="element-80">
                Average Monthly Savings
              </span>
              <span className="font-sans text-[13px] italic text-primary-dark/50 mt-1" data-id="element-81">
                from a single call
              </span>
            </div>
          </div>
        </div>

        {/* 3 Story Cards */}
        <div className="max-w-[700px] mx-auto space-y-6 mb-16" data-id="element-82">
          {/* Story 1 */}
          <div className="bg-warm-white border-l-[5px] border-gold-accent rounded-r-xl p-[36px_40px]" data-id="element-83">
            <h3 className="font-serif text-[22px] font-bold text-primary-emerald mb-1" data-id="element-84">
              Maria
            </h3>
            <p className="font-sans text-[13px] text-primary-dark/50 mb-4" data-id="element-85">
              $8,400 balance · 24.99% APR · Tuesday morning
            </p>
            <p className="font-sans text-[16px] text-primary-dark/80 mb-4" data-id="element-86">
              She read the script. Called at 9:15 AM. Fourteen minutes later —
            </p>
            <div className="bg-white border border-black/5 rounded p-4 mb-4 font-mono text-[14px] text-success-green" data-id="element-87">
              <div data-id="element-88">Rate: 24.99% → 17.99%</div>
              <div data-id="element-89">Monthly savings: $49</div>
              <div data-id="element-90">Annual savings: $588</div>
              <div className="font-bold" data-id="element-91">Lifetime savings: $1,400+</div>
            </div>
            <p className="font-sans italic text-[16px] text-primary-dark/70" data-id="element-92">
              "I had no idea you could just ask. I thought the rate was the
              rate."
            </p>
          </div>

          {/* Story 2 */}
          <div className="bg-warm-white border-l-[5px] border-gold-accent rounded-r-xl p-[36px_40px]" data-id="element-93">
            <h3 className="font-serif text-[22px] font-bold text-primary-emerald mb-1" data-id="element-94">
              Carlos
            </h3>
            <p className="font-sans text-[13px] text-primary-dark/50 mb-4" data-id="element-95">
              $3,200 balance · 22.99% APR · Almost didn't call
            </p>
            <p className="font-sans text-[16px] text-primary-dark/80 mb-4" data-id="element-96">
              He thought his balance was 'too small for them to care.' Eleven
              minutes proved him wrong.
            </p>
            <div className="bg-white border border-black/5 rounded p-4 mb-4 font-mono text-[14px] text-success-green" data-id="element-97">
              <div data-id="element-98">Rate: 22.99% → 16.99%</div>
              <div data-id="element-99">Monthly savings: $16</div>
              <div data-id="element-100">Payoff timeline: 3 weeks shorter</div>
              <div className="font-bold" data-id="element-101">
                Additional calls made: 2 more that afternoon
              </div>
            </div>
            <p className="font-sans italic text-[16px] text-primary-dark/70" data-id="element-102">
              "I felt stupid for not doing this sooner. Then I felt powerful.
              Then I told everyone."
            </p>
          </div>

          {/* Story 3 */}
          <div className="bg-warm-white border-l-[5px] border-gold-accent rounded-r-xl p-[36px_40px]" data-id="element-103">
            <h3 className="font-serif text-[22px] font-bold text-primary-emerald mb-1" data-id="element-104">
              David
            </h3>
            <p className="font-sans text-[13px] text-primary-dark/50 mb-4" data-id="element-105">
              4 cards · One Sunday afternoon · Changed everything
            </p>
            <p className="font-sans text-[16px] text-primary-dark/80 mb-4" data-id="element-106">
              David had four credit cards. Four different companies. He used the
              system on a Sunday over two and a half hours.
              <br data-id="element-107" />
              <br data-id="element-108" />
              Three of four calls succeeded immediately.
              <br data-id="element-109" />
              The fourth succeeded the following week — callback script.
            </p>
            <div className="bg-white border border-black/5 rounded p-4 mb-4 font-mono text-[14px] text-success-green" data-id="element-110">
              <div data-id="element-111">Combined monthly savings: $187</div>
              <div data-id="element-112">Annual savings: $2,244</div>
              <div className="font-bold" data-id="element-113">
                Time invested: One Sunday afternoon
              </div>
            </div>
            <p className="font-sans italic text-[16px] text-primary-dark/70" data-id="element-114">
              "I made more money that afternoon than I make in a full day of
              work."
            </p>
          </div>
        </div>

        {/* Math Box */}
        <div className="bg-warm-white border-[2px] border-gold-accent rounded-xl p-[40px] max-w-[600px] mx-auto text-center" data-id="element-115">
          <h3 className="font-serif text-[26px] text-primary-dark mb-6" data-id="element-116">
            This book costs $9.99.
          </h3>
          <div className="font-sans text-[18px] text-primary-dark/80 leading-[2] mb-8" data-id="element-117">
            <p data-id="element-118">Chapter 5 saves $50–$100 per month.</p>
            <p data-id="element-119">That's 5–10× your investment.</p>
            <p data-id="element-120">In your first 12 minutes.</p>
            <p data-id="element-121">On your first call.</p>
          </div>
          <p className="font-serif font-bold text-[22px] text-gold-accent mb-10" data-id="element-122">
            "You make your money back before you finish reading."
          </p>

          <CTAButton subText="Get the scripts · Make the call · Save tonight" data-id="element-123">
            I WANT TO MAKE THAT CALL — $9.99
          </CTAButton>
        </div>
      </div>
    </section>;
}